import { useContext, useEffect, useState } from 'react';
import { ServiceContext } from '../../contexts/ServiceContext';
import { DEFAULT_EXPIRING_INTERVAL_DAYS, parseExpiringInterval } from '../../helpers/ExpiryRule';

// The company's "expiring" threshold, the setting the side pane used to read on its own. It is null until the
// setting resolves (nothing may be called expiring against a threshold that is not known yet), and falls back
// to the default when the read fails or the setting is unparsable, which is what the pane always did.
export const useExpiringInterval = () => {
	const { locationService } = useContext(ServiceContext);
	const [expiringInterval, setExpiringInterval] = useState(null);

	useEffect(() => {
		let isCurrent = true;

		const loadExpiringInterval = async () => {
			let interval = DEFAULT_EXPIRING_INTERVAL_DAYS;

			try {
				const renewalsSettings = await locationService.getLocationsRenewalsSettings();

				interval = parseExpiringInterval(renewalsSettings?.expiringIntervalSettingForCustomer);
			} catch (error) {
				// Keep the default: the list must still show its dates and add-ons without the company setting.
			}

			if (isCurrent) {
				setExpiringInterval(interval);
			}
		};

		loadExpiringInterval();

		return () => {
			isCurrent = false;
		};
	}, []);

	return expiringInterval;
};
